module.exports = __webpack_public_path__ + "img/terroir-tinted-4-mobile.74acbfd8.jpg";